import React from "react"
import { Text as TextCore } from "~widgets/text"
import { TextProps } from "~widgets/text/text.props"
import styled from '~/ui/styled'

const Text = styled(TextCore)`
  line-height: 28px;
  color: gray;
`

interface AccordionTextProps extends TextProps {}

const AccordionText: React.FC<AccordionTextProps> = (props) => {
  return <Text {...props} />
}
export default AccordionText
